<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div class="card" *ngIf="moduleAccess=='Full'">
	<h2 class="card-title mb-0 pb-0">
		Ranks
	</h2>
	<div class="card-body pt-1">
		<div class="row">
			<div class="col-md-12">
				<div class="table-responsive">
					<table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered table-hover"
						style="width: 100%;">
						<thead>
							<tr class="table_head">
								<th style="width: 100% !important;">Rank</th>
								<!-- <th style="width: 50% !important;">Category</th> -->
							</tr>
						</thead>
						<tbody *ngIf="dataList?.length != 0">
							<tr *ngFor="let v of dataList;let i = index;">
								<td>{{ v.rank }}</td>
								<!-- <td>{{ v.category }}</td> -->
							</tr>
						</tbody>
						<tbody *ngIf="dataList?.length == 0">
							<tr>
								<td colspan="1" class="text-center">No data found!</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="moduleAccess!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>